import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';

export default async function getSystemInfo(plant_id) {
  if(!plant_id) {
    throw new Error('Plant ID is required');
  }

  const res = await axiosService({
    method: 'post',
    data: {
      path: `/installation`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });
  const data = res?.data?.result;

  if (res?.codeHTTP === 200 && data && data.peakPower && data.startUpUtc) {
    return data;
  } else {
    return checkError(res, getSystemInfo, plant_id);
  }
}

// const apiSystemInfo = async () => {
//   const res = await axiosService({
//     method: 'post',
//     params: {
//       path: `/installation`,
//       // eslint-disable-next-line camelcase
//       plant_id: id,
//     },
//     apiPath: `${API.PLANT_MANAGEMENT}`,
//   });
//   const data = res?.data?.result;
//   if (res?.codeHTTP === 200 && data && data.peakPower && data.startUpUtc) {
//     setSystemInfo({
//       peakPower: (data.peakPower / 1000).toFixed(1),
//       startUpUtc: dayjs(data.startUpUtc).format('DD MMM YYYY'),
//       dcPowerInputMax: (data.dcPowerInputMax / 1000).toFixed(1),
//     });
//   } else {
//     await checkError(res, apiSystemInfo);
//   }
// };
